module.exports = {"130802001":"西大街街道","130802002":"头道牌楼街道","130802003":"潘家沟街道","130802004":"中华路街道","130802005":"新华路街道","130802006":"石洞子沟街道","130802007":"桥东街道","130802100":"水泉沟镇","130802101":"狮子沟镇","130802102":"牛圈子沟镇","130802103":"大石庙镇","130802105":"双峰寺镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130802.json
// module id = 200
// module chunks = 0